import * as S from './styles';
import { FmdBadOutlined } from '@mui/icons-material';

export default function NoClassSectionData() {
  return (
    <S.EmptyStateContainer>
      <FmdBadOutlined
        sx={{
          width: 60,
          height: 70,
          color: '#C2C1C1',
        }}
      />

      <S.MessageText>目前尚未建立本校的課程分班。</S.MessageText>
      <S.MessageText>請點擊下方「建立分班」按鈕以建立分班。</S.MessageText>
    </S.EmptyStateContainer>
  );
}
